import { Layout, Typography } from "antd";
import styled from "styled-components";

import { MainContainer } from "@/components/Layout/Styled";

export const ButtonsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 16px;
    margin-bottom: 20px;
    background-color: ${(props) => props.theme.primaryBackground};
`;

export const StyledTypographyFormWarning = styled(Typography)`
    text-align: left;
    color: #d87a16 !important;
    font-weight: 500;
    line-height: 120%;
`;

export const SearchWrapper = styled(Layout)`
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 16px;
    align-items: center;
    flex-direction: row;

    .ant-input::placeholder {
        color: ${(props) => props.theme.secondaryTypographyColor};
    }
    .ant-select-selection-placeholder {
        color: ${(props) => props.theme.secondaryTypographyColor};
    }
`;

export const StyledFormWarning = styled.div`
    width: 100%;
    padding: 10px 16px;
    background-color: #2b2111;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 1;
    border: 1px solid rgba(255, 215, 5, 0.1);
`;

export const StyledTypographySum = styled(Typography)`
    color: white;
`;

export const StyledSum = styled.div`
    width: 100%;
    padding: 2px 8px;
    background-color: ${({ theme }) => theme.colors.primary};
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

export const StyledContentContainer = styled(MainContainer)`
    padding: 16px 16px 10px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const StyledSearchWrapper = styled(Layout)`
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 16px;
    align-items: center;
    flex-direction: row;

    .ant-input::placeholder {
        color: ${(props) => props.theme.secondaryTypographyColor};
    }
    .ant-select-selection-placeholder {
        color: ${(props) => props.theme.secondaryTypographyColor};
    }
`;
